var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1.9246C19.2645 2.25049 18.4744 2.47069 17.6438 2.57022C18.4911 2.06289 19.1412 1.25779 19.4477 0.299448C18.655 0.769831 17.7768 1.11157 16.8423 1.29478C16.0935 0.498549 15.0277 0 13.8474 0C11.582 0 9.74457 1.83739 9.74457 4.10463C9.74468 4.41884 9.78013 4.73204 9.85026 5.03833C6.43884 4.86654 3.41671 3.2326 1.39259 0.75045C1.04029 1.35822 0.837662 2.06289 0.837662 2.81334C0.837662 4.23672 1.56262 5.49368 2.66273 6.22919C2.01117 6.20844 1.37398 6.03237 0.804198 5.71565V5.7685C0.804198 7.75649 2.21793 9.4151 4.09584 9.79212C3.74346 9.88719 3.38004 9.93517 3.01506 9.9348C2.75588 9.93501 2.49726 9.91083 2.24261 9.86257C2.76493 11.4921 4.27995 12.6794 6.07595 12.7111C4.67101 13.8122 2.90145 14.4684 0.979483 14.4684C0.648294 14.4684 0.321498 14.449 0 14.4111C1.81628 15.5765 3.97254 16.2547 6.28909 16.2547C13.8377 16.2547 17.9644 10.0026 17.9644 4.58027C17.9644 4.40412 17.96 4.22617 17.9521 4.05002C18.7536 3.47042 19.4495 2.74904 19.9982 1.92723L20 1.9246Z",
    fill: "#1DA1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon03);
export default __webpack_public_path__ + "static/media/login-icon-03.2cf4c9c33b25c8d295e202aef0ee6527.svg";
export { ForwardRef as ReactComponent };